
const refreshData = (searchParams) => {

  // document.getElementById('restaurant-list-id').innerHTML = '<div class="j360-loading">Loading...</div>';
  // fetch data
  for (const key in j360ListParams) {
    searchParams.set(key, j360ListParams[key]);
  }

  searchParams.set('j360_component', 'j360-blocks/restaurant-list');

  fetch(`/wp-json/j360/v1/test?${searchParams.toString()}`)
  .then((res) => res.text())
  .then((data) => {
    if (!data) {
      return;
    }
    document.getElementById('restaurant-list-id').innerHTML = data;
  });
}

function j360FilterChanged (key, value) {
  const url = new URL(window.location.href);
  const filterKey = `filter_${key}`;
  if (value) {
    url.searchParams.set(filterKey, value);
  } else {
    url.searchParams.set(filterKey, 'show_all');
    // url.searchParams.delete(filterKey);
  }
  url.searchParams.delete('jpage');
  window.history.pushState('', '', url.toString());
  refreshData(url.searchParams);
}

function j360SortChanged (type, key, direction) {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_type', type);
  url.searchParams.set('sort_key', key);
  url.searchParams.set('sort_direction', direction);
  url.searchParams.delete('jpage');
  window.history.pushState('', '', url.toString());
  refreshData(url.searchParams);
}

function j360onFilterDropdownToggle (key) {
  // close all other filters
  const cssClass = 'j360-filter'
  const elements = document.getElementsByClassName(cssClass);
  for (let i = 0; i < elements.length; i++) {
    if (elements[i].id !== key) {
      elements[i].classList.remove('active');
    }
  }

  document.querySelectorAll(`#${key}`).forEach((element) => {
    element.classList.toggle('active');
  })
}

function j360onFilterValueSelected(event, key) {
  if (event.target.classList.contains('not-selected')) {
    window.j360FilterChanged(key, '');
  } else {
    window.j360FilterChanged(key, event.target.id);
  }


  if (key === 'j360_location') {
    const elements = document.getElementsByClassName('wp-block-j360-blocks-display-selected-location');
    for (let i = 0; i < elements.length; i++) {
      elements[i].innerHTML = event.target.getAttribute('data-name');
    }
  }
}

function j360SortToggled(event, id, type, key) {
  // console.log(event.target.getAttribute('data-sort'), event.target.classList.contains('ascending'), event.target.classList.contains('descending'));
  // console.log('event.target', event.target);
  const element = document.getElementById(id);
  var sortDirection = element.getAttribute('aria-sort');
  var newSortDirection = sortDirection === 'ascending' ? 'descending' : 'ascending';

  // check if the current url has the sort key and if it is not our key, don't change the sort direction
  const url = new URL(window.location.href);
  if (url.searchParams.get('sort_key') !== key) {
    newSortDirection = 'descending';
  }
  window.j360SortChanged(type, key, newSortDirection);
  element.setAttribute('aria-sort', newSortDirection);
}

window.j360FilterChanged = j360FilterChanged;
window.j360SortChanged = j360SortChanged;
window.j360onFilterDropdownToggle = j360onFilterDropdownToggle;
window.j360onFilterValueSelected = j360onFilterValueSelected;
window.j360SortToggled = j360SortToggled;